
import Form from '@/ui-kit/components/form';
import FormField from '@/ui-kit/components/form/form-field';
import { InputFillType } from '@/ui-kit/components/form/controls/shared/input/enums';
import { FormFieldProperty } from '@/ui-kit/components/form/enums';
import { ControlType } from '@/ui-kit/components/form/controls/enums';
import { SelectProperty } from '@/ui-kit/components/form/controls/components/select/enums';
import { DatePeriodFormControlName, DatePeriodMode, DatePeriodProperty } from './enums';
import { DATE_PERIOD_OPTIONS_BY_MODE } from './constants';
import BaseForm from '../../mixins/BaseForm';

export default {
  name: 'LocationForm',
  components: {
    Form,
    FormField,
  },
  mixins: [BaseForm],
  props: {
    [DatePeriodProperty.DatePeriodMode]: {
      type: String,
      default: DatePeriodMode.Full,
    },
  },
  data() {
    return {
      DatePeriodFormControlName,
      FormFieldProperty,
      ControlType,
    };
  },
  computed: {
    datePeriodControl() {
      return this.getControl(DatePeriodFormControlName.DatePeriod);
    },
    datePeriod() {
      return this.datePeriodControl?.value;
    },
    datePeriodInputProps() {
      return {
        [SelectProperty.FillType]: InputFillType.Underlined,
        [SelectProperty.Label]: 'Date period',
        [SelectProperty.Options]: DATE_PERIOD_OPTIONS_BY_MODE[this.datePeriodMode],
      };
    },
  },
  watch: {
    datePeriodMode(mode) {
      const options = DATE_PERIOD_OPTIONS_BY_MODE[mode];
      const isExistingValue = options.find(({ value }) => value === this.datePeriod);

      if (!isExistingValue) {
        this.datePeriodControl.reset();
      }
    },
  },
};
